const doesCustomerExist = async (email) => {
    const url = `${getAppUrl()}/api/doesCustomerExist?email=${email}`;
    return await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if(response.ok) {
                return response.json();
            } else {
                throw new Error('Server response wasn\'t OK');
            }
        })
};
